import { withSentryReactRouterV6Routing } from "@sentry/react";
import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";

export const SentryRoutes = withSentryReactRouterV6Routing(Routes);

const Sandbox = lazy(() => import("./sandbox"));
const Flow = lazy(() => import("./flow"));
const ShowPoster = lazy(() => import("./show-poster"));

function Loading() {
  return (
    <main className="flex flex-col justify-center">
      <h1 className="text-2xl">Laden...</h1>
    </main>
  );
}

function Home() {
  return (
    <main className="flex flex-col justify-center items-center h-screen">
      <h1 className="text-xl text-gray-600">EDUbox Circulaire Economie</h1>
    </main>
  );
}

function App() {
  return (
    <Suspense fallback={<Loading />}>
      <SentryRoutes>
        <Route path="/sandbox" element={<Sandbox />} />
        <Route path="/flow/*" element={<Flow />} />
        <Route path="/poster/:id" element={<ShowPoster />} />
        <Route path="/" element={<Home />} />
      </SentryRoutes>
    </Suspense>
  );
}

export default App;
